import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="border-t border-border bg-muted/60" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col justify-between gap-10 px-6 py-16 md:flex-row md:items-end lg:px-10">
      <div className="space-y-6">
        <Logo size="sm" showTagline />
        <a href="https://www.instagram.com/nia.ecoversity/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
          className="inline-flex items-center gap-2 text-sm font-semibold text-plum transition-colors hover:text-primary">
          <Instagram className="h-5 w-5" /> @nia.ecoversity
        </a>
      </div>
      <div className="flex flex-wrap gap-8 text-sm text-foreground/70">
        <Link to="/about" className="hover:text-primary" data-testid="footer-about-link">About</Link>
        <Link to="/offerings" className="hover:text-primary" data-testid="footer-offerings-link">What we offer</Link>
        <Link to="/join" className="hover:text-primary" data-testid="footer-join-link">Join the village</Link>
        <Link to="/contact" className="font-semibold text-primary" data-testid="footer-enquire-link">Contact</Link>
      </div>
    </div>
    <div className="border-t border-border/70 py-6 text-center text-xs text-foreground/55">
      © {new Date().getFullYear()} Nia Ecoversity
    </div>
  </footer>
);
